// Autogenerated file
export const bidRolesEnum = {
    Creator: "Creator",
    Responsible: "Responsible",
    CarLogist: "CarLogist",
    SalesManager: "SalesManager",
};
export const bidRoles = [
    { label: "Автор заявки", value: "Creator" },
    { label: "Ответственный", value: "Responsible" },
    { label: "Логист", value: "CarLogist" },
    { label: "Менеджер по продажам", value: "SalesManager" },
];
